<template>
  <div v-if="isModalStatus">
    <div class="withdraw_modal">
      <div class="withdraw_overlay"></div>
      <div class="withdraw_modal_position text-center">
        <div class="d-inbl" style="z-index: 11">
          <div class="mb-5 withdraw_container">
            <img :src="`${$s3}/img/common/login/new_logo.svg?${$ver}`" class="w-100" />
          </div>
          <div class="text big d-inbl" v-html="$t(first)"></div>
          <div class="text small mt-3" v-html="$t(second)"></div>
          <div class="mt-4">
            <b-button
              @click="isWithDraw()"
              :style="{
                background: '#0a57d4',
                borderRadius: '50px',
                color: '#fff',
                border: 0,
                padding: !isMobile ? '10px 30px' : '5px 15px',
                'font-weight': 400,
                'font-size': !isMobile ? '1rem' : '12px',
              }"
            >
              {{ $t('modal.confirm') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Withdraw',
  props: {},
  mounted() {
    this.$store.commit('isWithDraw', { withdraw: false });
  },
  created() {},
  computed: {
    ...mapState({
      isModalStatus: (state) => state.withDraw,
      isMobile: (state) => state.isMobile,
    }),
  },
  data() {
    return {
      first: 'etc.withdraw.title',
      second: 'etc.withdraw.title1',
    };
  },
  methods: {
    isWithDraw() {
      this.isModalStatus = false;
    },
  },
};
</script>

<style lang="postcss">
@keyframes open_withdraw_modal {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.withdraw_modal,
.withdraw_overlay {
  animation: open_withdraw_modal 0.2s;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 80px;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
}
.withdraw_overlay {
  background-color: rgba(255, 255, 255, 1);
}
.withdraw_modal_position {
  display: grid;
  place-items: center;
  height: 80%;
}
.withdraw_container {
  width: 600px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  min-height: 100%;
}
.text {
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: -0.25px;
  text-align: center;
  color: #000;
  word-break: keep-all;
  white-space: pre-line;
}
.text.big {
  font-size: 48px;
  font-weight: bold;
}
.text.small {
  font-size: 20px;
}
.d-inbl {
  display: inline-block;
}
@media screen and (max-width: 992px) {
  .withdraw_container {
    width: 70%;
    display: inline-block;
  }
  .text.big {
    width: 90%;
    font-size: 20px;
  }
  .text.small {
    font-size: 15px;
  }
}
</style>
